import { render, staticRenderFns } from "./ListApolicestatuPage.vue?vue&type=template&id=147029c0"
import script from "./ListApolicestatuPage.vue?vue&type=script&lang=js"
export * from "./ListApolicestatuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports